export default __webpack_public_path__ + "static/media/Toyota1.ff62c098.jpg";